// @ts-strict-ignore
import { ArrayUtils } from '@shared/util/array-utils';
import { StringUtils } from '@shared/util/string-utils';
import { NumberUtils } from '@shared/util/number-utils';
import { ArticleCollectionVO } from '@article/model/vo/article.vo';

export class ArticleCollectionUtils {
  public static createArticleCollection(type: string, articleIds: number[] = null, userId: number = NaN): ArticleCollectionVO {
    let articleCollection: ArticleCollectionVO = null;
    if (type === ArticleCollectionVO.TYPE_FAVORITES) {
      articleCollection = ArticleCollectionVO.create('key:items.label.favorites_article_collection', ArticleCollectionVO.TYPE_FAVORITES, articleIds);
    } else {
      articleCollection = ArticleCollectionVO.create('', type, articleIds);
    }
    articleCollection.userId = userId;
    return articleCollection;
  }

  public static mergeArticleCollections(sourceArticleCollection: ArticleCollectionVO, targetArticleCollection: ArticleCollectionVO): boolean {
    if (!sourceArticleCollection || !targetArticleCollection) {
      return false;
    }
    const sourceArticleIds: number[] = sourceArticleCollection.articleIds;
    if (ArrayUtils.isEmpty(sourceArticleIds)) {
      return false;
    }
    let targetArticleIds: number[] = targetArticleCollection.articleIds;
    if (!targetArticleIds) {
      targetArticleIds = [];
    }
    let targetArticleIdsModified: boolean = false;
    for (let i: number = 0; i < sourceArticleIds.length; i++) {
      const sourceArticleId: number = sourceArticleIds[i];
      if (targetArticleIds.indexOf(sourceArticleId) === -1) {
        targetArticleIds.push(sourceArticleId);
        targetArticleIdsModified = true;
      }
    }
    if (targetArticleIdsModified) {
      targetArticleCollection.articleIds = targetArticleIds.concat();
    }
    return targetArticleIdsModified;
  }

  public static getArticleCollectionByType(articleCollections: ArticleCollectionVO[], type: string): ArticleCollectionVO {
    if (ArrayUtils.isEmpty(articleCollections)) {
      return null;
    }
    for (let i: number = 0; i < articleCollections.length; i++) {
      const articleCollection: ArticleCollectionVO = articleCollections[i];
      if (articleCollection && articleCollection.type === type) {
        return articleCollection;
      }
    }
    return null;
  }

  public static getArticleCollectionByTypeAndNameAndUserId(
    articleCollections: ArticleCollectionVO[],
    type: string,
    name: string,
    userId: number
  ): ArticleCollectionVO {
    if (!articleCollections || StringUtils.isEmpty(name) || !NumberUtils.isNumber(userId)) {
      return null;
    }
    for (let i: number = 0; i < articleCollections.length; i++) {
      const articleCollection: ArticleCollectionVO = articleCollections[i];
      if (articleCollection && articleCollection.type === type && articleCollection.name === name && articleCollection.userId === userId) {
        return articleCollection;
      }
    }
    return null;
  }

  public static removeArticleFromArticleCollection(articleCollection: ArticleCollectionVO, articleId: number): void {
    if (!articleCollection || ArrayUtils.isEmpty(articleCollection.articleIds)) {
      return;
    }
    const articleIndex: number = articleCollection.articleIds.indexOf(articleId);
    if (articleIndex === -1) {
      return;
    }
    articleCollection.articleIds.splice(articleIndex, 1);
  }
}
